module.exports = "/_next/static/images/LowRecencyPurchaseWinbackDesktop-153afa48d555e39e0b3fb6d79c535e99.png";